import PaycurraLogo from "../assets/logo/logo-paycurra.svg";
import MasterCardLogo from "../assets/images/mastercard-logo.png";
import VerveLogo from "../assets/images/verve.svg";
import VisaLogo from "../assets/images/visa.svg";
import OrderConfirmedImage from "../assets/5400.svg"

import AppleStoreImg from "../assets/images/App-Store.svg";
import PlayStoreImg from "../assets/images/Google-Play.svg";
import MMobile1MockUp from "../assets/images/Mobile-1-mobile.svg";
import MMobile2MockUp from "../assets/images/Mobile-2-mobile.svg";
import DMobileBotttomMockUp from "../assets/images/mobile-bottom-desktop.svg";
import DMobileTopMockUp from "../assets/images/mobile-top-desktop.svg";

export const images = {
  PaycurraLogo,
  MasterCardLogo,
  VerveLogo,
  VisaLogo,
  OrderConfirmedImage,
  AppleStoreImg,
  PlayStoreImg,
  MMobile1MockUp,
  MMobile2MockUp,
  DMobileBotttomMockUp,
  DMobileTopMockUp,
};
